import React, { type PropsWithChildren, useCallback, useState } from 'react';
import { GoogleReCaptcha, GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import {
  GoogleRecaptchaV3Context,
} from './GoogleRecaptchaV3Context';

type GoogleRecaptchaV3ProviderProps = {
  reCaptchaKey: string;
};

export const GoogleRecaptchaV3Provider =
  ({ children, reCaptchaKey }: PropsWithChildren<GoogleRecaptchaV3ProviderProps>) => {
    const [reCaptchaToken, setReCaptchaToken] = useState('');
    const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);

    const handleVerify = useCallback((token) => {
      setReCaptchaToken(token);
    }, [setReCaptchaToken]);

    const handleSetRefreshReCaptcha = useCallback(
      () => setRefreshReCaptcha(!refreshReCaptcha),
      [setRefreshReCaptcha, refreshReCaptcha],
    );

    const providerValue = {
      reCaptchaToken,
      handleSetRefreshReCaptcha,
    };

    return (
      <GoogleRecaptchaV3Context.Provider value={providerValue}>
        <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey}>
          <GoogleReCaptcha onVerify={handleVerify}
                           refreshReCaptcha={refreshReCaptcha} />
          {children}
        </GoogleReCaptchaProvider>
      </GoogleRecaptchaV3Context.Provider>
    );
  };
